module.exports = "//static.hsappstatic.net/ui-forms-components/static-1.6714/img/properties/date-picker.png"